import reportUrlsModule from './report-urls.module.js';

export default reportUrlsModule;
